import './App.scss';
import MyRoutes from './MyRoutes';
import { BrowserRouter } from "react-router-dom";

function App() {
  return (<div className="App">
    <BrowserRouter>
      <MyRoutes />
    </BrowserRouter>
  </div>);
}

export default App;